'use client';

import Link from 'next/link';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white shadow rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">
            Политика конфиденциальности
          </h1>
          
          <div className="prose prose-blue max-w-none text-gray-600 space-y-6">
            <p className="text-sm text-gray-500">
              Последнее обновление: {new Date().toLocaleDateString('ru-RU')}
            </p>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                1. Общие положения
              </h2>
              <p>
                Настоящая Политика конфиденциальности определяет порядок обработки 
                и защиты персональных данных пользователей сервиса Supplier 
                (далее — «Сервис»).
              </p>
              <p>
                Используя Сервис, вы соглашаетесь с условиями данной Политики 
                конфиденциальности.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                2. Какие данные мы собираем
              </h2>
              <p>Мы можем собирать следующие категории данных:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong>Данные учётной записи:</strong> имя, адрес электронной почты, 
                  номер телефона
                </li>
                <li>
                  <strong>Данные об использовании:</strong> информация о том, как вы 
                  используете Сервис, включая журналы доступа
                </li>
                <li>
                  <strong>Технические данные:</strong> IP-адрес, тип браузера, 
                  операционная система
                </li>
                <li>
                  <strong>Данные маркетплейсов:</strong> API-ключи и данные интеграций, 
                  которые вы предоставляете для работы Сервиса
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                3. Как мы используем данные
              </h2>
              <p>Собранные данные используются для:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Предоставления и улучшения Сервиса</li>
                <li>Аутентификации и обеспечения безопасности</li>
                <li>Связи с вами по вопросам использования Сервиса</li>
                <li>Выполнения интеграций с маркетплейсами</li>
                <li>Анализа использования для улучшения функциональности</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                4. Защита данных
              </h2>
              <p>
                Мы применяем современные методы защиты данных:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Шифрование данных при передаче (TLS/SSL)</li>
                <li>Хеширование паролей с использованием bcrypt</li>
                <li>Ограниченный доступ к персональным данным</li>
                <li>Регулярное резервное копирование</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                5. Передача данных третьим лицам
              </h2>
              <p>
                Мы не продаём и не передаём ваши персональные данные третьим лицам, 
                за исключением случаев:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Когда это необходимо для работы Сервиса (интеграции с маркетплейсами)</li>
                <li>По требованию законодательства</li>
                <li>С вашего явного согласия</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                6. Ваши права
              </h2>
              <p>Вы имеете право:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Получить доступ к своим персональным данным</li>
                <li>Исправить неточные данные</li>
                <li>Удалить свою учётную запись и связанные данные</li>
                <li>Отозвать согласие на обработку данных</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                7. Cookies
              </h2>
              <p>
                Сервис использует cookies для аутентификации и улучшения 
                пользовательского опыта. Вы можете отключить cookies в настройках 
                браузера, однако это может повлиять на работу Сервиса.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                8. Изменения политики
              </h2>
              <p>
                Мы можем обновлять данную Политику конфиденциальности. 
                О существенных изменениях мы уведомим вас через Сервис или 
                по электронной почте.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                9. Контакты
              </h2>
              <p>
                По вопросам, связанным с обработкой персональных данных, 
                обращайтесь по адресу:{' '}
                <a href="mailto:privacy@crossales.ru" className="text-blue-600 hover:underline">
                  privacy@crossales.ru
                </a>
              </p>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link
              href="/login"
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              ← Вернуться к входу
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
